import type {
  IOpportunityMSServiceDocument,
  IOpportunityMSServiceUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createOpportunityMSServiceDocument,
  updateDocument: updateOpportunityMSServiceDocument,
  deleteDocument: deleteOpportunityMSServiceDocument,
} = makeDocumentService<
  IOpportunityMSServiceDocument,
  IOpportunityMSServiceUploadDocument
>('/api/opportunitymsservicedocuments', 'opportunityMSServiceDocument')
